import React from 'react';

function TrashIcon({ size = 16, color = 'currentColor', className, ariaHidden = true }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width={size}
      height={size}
      aria-hidden={ariaHidden}
      className={className}
    >
      <path d="M3 6h18" />
      <path d="M9 6V4h6v2" />
      <path d="M10 11v6" />
      <path d="M14 11v6" />
      <path d="M5 6l1 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-14" />
    </svg>
  );
}

function TrashButton({ onClick, size = 16, className = '', ...props }) {
  return (
    <button className={`poll-remove ${className}`.trim()} onClick={onClick} {...props}>
      <TrashIcon size={size} />
    </button>
  );
}

export { TrashButton };
export default TrashIcon;
